var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3325 21.3333V14.6666H15.6658V21.3333C15.6658 22.0666 16.2658 22.6666 16.9992 22.6666H20.9992C21.7325 22.6666 22.3325 22.0666 22.3325 21.3333V12H24.5992C25.2125 12 25.5058 11.24 25.0392 10.84L13.8925 0.799961C13.3858 0.346628 12.6125 0.346628 12.1058 0.799961L0.959154 10.84C0.505821 11.24 0.785821 12 1.39915 12H3.66582V21.3333C3.66582 22.0666 4.26582 22.6666 4.99915 22.6666H8.99915C9.73249 22.6666 10.3325 22.0666 10.3325 21.3333Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlue);
export default __webpack_public_path__ + "static/media/dashboardBlue.c5eda874fa53e37cbd8d4929b1c4b064.svg";
export { ForwardRef as ReactComponent };